import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-homepage-logo",
  templateUrl: "./homepage-logo.component.html",
  styleUrls: ["./homepage-logo.component.scss"],
})
export class HomepageLogoComponent implements OnInit, OnDestroy {
  @Input() startAnimationLogo;
  @Input() groupApp;
  @Input() rootDir;
  @Input() selectedLogoFileName;
  @Input() windowDimensions;
  @Input() hasHomepageInlineText = false;
  public three_buttons;
  public four_buttons;
  private logoTapCount = 0;
  private logoTapTimeout: any;

  constructor(private router: Router) {}

  ngOnInit() {
    this.caluclateButtonsActive();
  }

  ngOnDestroy() {
    if (this.logoTapTimeout) {
      clearTimeout(this.logoTapTimeout);
      this.logoTapTimeout = null;
    }
  }

  caluclateButtonsActive() {
    this.four_buttons = false;
    this.three_buttons = false;
    if (
      this.groupApp &&
      this.groupApp.design_settings &&
      this.groupApp.design_settings.customHomepageButtons &&
      this.groupApp.design_settings.customHomepageButtons.active &&
      this.groupApp.design_settings.customHomepageButtons.button_one &&
      this.groupApp.design_settings.customHomepageButtons.button_one.active &&
      !(
        this.groupApp.design_settings.customHomepageButtons.button_two &&
        this.groupApp.design_settings.customHomepageButtons.button_two.active
      )
    ) {
      this.four_buttons = false;
      this.three_buttons = true;
    } else if (
      this.groupApp &&
      this.groupApp.design_settings &&
      this.groupApp.design_settings.customHomepageButtons &&
      this.groupApp.design_settings.customHomepageButtons.active &&
      this.groupApp.design_settings.customHomepageButtons.button_two &&
      this.groupApp.design_settings.customHomepageButtons.button_two.active &&
      !(
        this.groupApp.design_settings.customHomepageButtons.button_one &&
        this.groupApp.design_settings.customHomepageButtons.button_one.active
      )
    ) {
      this.four_buttons = false;
      this.three_buttons = true;
    } else if (
      this.groupApp &&
      this.groupApp.design_settings &&
      this.groupApp.design_settings.customHomepageButtons &&
      this.groupApp.design_settings.customHomepageButtons.active &&
      this.groupApp.design_settings.customHomepageButtons.button_two &&
      this.groupApp.design_settings.customHomepageButtons.button_two.active &&
      this.groupApp.design_settings.customHomepageButtons.button_one &&
      this.groupApp.design_settings.customHomepageButtons.button_one.active
    ) {
      this.four_buttons = true;
      this.three_buttons = false;
    }
  }

  handleLogoTap() {
    if (Capacitor.isNativePlatform()) {
      return;
    }

    this.logoTapCount += 1;

    if (this.logoTapTimeout) {
      clearTimeout(this.logoTapTimeout);
    }

    if (this.logoTapCount >= 10) {
      this.logoTapCount = 0;
      this.logoTapTimeout = null;
      this.router.navigateByUrl("/uposlogin");
      return;
    }

    this.logoTapTimeout = setTimeout(() => {
      this.logoTapCount = 0;
      this.logoTapTimeout = null;
    }, 2000);
  }
}
